import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Local Navbar'
export const group = 'navbar'


export const defaultOptions = {
  localNavbar: true,
  'customize': {
    'style': {'navbarScroller': {'type': 'navbar-scroller-customs', 'scrollType': null}},
    'display': true
  },
  'content': {
    'logo': {
      'type': 'logo-mod',
      'display': true,
      'fontFamily': null,
      'fontWeight': 'bold',
      'fontSize': '24px',
      'color': '#0C226C',
      'text': 'AppStarter'
    }, 'menuItems': {'type': 'menu-items-mod-v2', 'display': true}, 'subject': {
      'uid': 'WKtPEOYr2',
      'sid': 'lgpogktx6j--lmPOn_f8KN',
      'name': 'Flex Wrapper',
      'hideFromSections': false,
      'component': 'ElFlexWrapperV2',
      'group': 'navbar',
      'layout': null,
      'specialCols': {
        'navigation': {
          'special': true,
          'sid': 'lq3mz432--OFiJgs9lhG',
          'placement': 'bottom',
          'hamburgerIcon_open': 'fa fa-bars',
          'hamburgerIcon_close': 'fa fa-times',
          'hamburgerIcon_color': '#656565',
          'showOn': 'lg',
          'name': 'Nav Column',
          'elements': [{
            'display': true,
            'name': 'Flex Wrapper',
            'hideFromSections': false,
            'component': 'ElFlexWrapperV2',
            'group': '',
            'layout': null,
            'options': {
              'content': {
                'display': true, 'cols': [{
                  'display': true,
                  'name': 'Flex Column',
                  'elements': [{
                    'uid': 'BlbxyqYc0',
                    'display': true,
                    'name': 'Menu Links',
                    'sid': 'lgpogktx6j--xhs67huAMW',
                    'hideFromSections': false,
                    'component': 'ElMenuLinksV4',
                    'group': 'Navigation',
                    'layout': null,
                    'options': {
                      'content': {
                        'menu': {
                          'display': true,
                          'type': 'menu-links-mod-v4',
                          'links': [{
                            'id': '2lgcfYKlUS',
                            'href': '#',
                            'text': 'About',
                            'customLink': false,
                            'blank': false,
                            'itemType': '',
                            'children': []
                          }, {
                            'id': 'kE_0CEF0hZ',
                            'href': '#',
                            'text': 'Work with Me',
                            'customLink': false,
                            'blank': false,
                            'itemType': '',
                            'children': []
                          }, {
                            'id': 'wJGQ-hWnL1',
                            'href': '#',
                            'text': 'Resources',
                            'customLink': false,
                            'blank': false,
                            'itemType': '',
                            'children': []
                          }, {
                            'id': 'A_dvOV_wIV',
                            'href': '#',
                            'text': 'Blog',
                            'customLink': false,
                            'blank': false,
                            'itemType': '',
                            'children': []
                          }, {
                            'id': 'QlHAT-G7Lw',
                            'href': '#',
                            'text': 'Contact',
                            'customLink': false,
                            'blank': false,
                            'children': []
                          }]
                        }
                      }
                    },
                    'editor': 'project',
                    'temp_id': 'KL8FXUhHuN'
                  }],
                  'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
                  'uid': 'pWLTiTXxla',
                  'sid': 'lgpogktx6j--EAr_fuuhgH',
                  'highlight': false,
                  'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
                }, {
                  'display': true,
                  'name': 'Flex Column',
                  'elements': [{
                    'uid': 'oCKQ7xxGP',
                    'display': true,
                    'name': 'Button',
                    'sid': 'lgpogktx6j--sy0a5NLuwd',
                    'hideFromSections': false,
                    'component': 'ElButtonV2',
                    'group': 'Media',
                    'layout': null,
                    'options': {
                      'content': {
                        'button': {
                          'pressetID': 0,
                          'display': true,
                          'type': 'button-mod-v2',
                          'text': 'Click Me',
                          'buttonType': 'button',
                          'icon': {'lottie': {'jsonPath': '', 'loop': true, 'autoplay': true}},
                          'hoverAnimation': {},
                          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
                        }
                      }, 'customize': null
                    },
                    'editor': 'project',
                    'temp_id': '-BOgEagQ0x'
                  }],
                  'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
                  'uid': 'KpHL-gmXzS',
                  'sid': 'lgpogktx6j--qCGWtUHQWx',
                  'highlight': false,
                  'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
                }], 'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
              }
            },
            'uid': '68Twket09',
            'sid': 'lgpogktx6j--IOedpL_VSc',
            'temp_id': 'kb5eyU6NYu'
          }],
          'highlight': false,
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50},
          'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
          'uid': 'lY3a8s-qQw',
          'navbarBackground': {'background': '', 'gradient': {'position': '', 'color': ''}}
        }
      },
      'options': {
        'content': {
          'display': true,
          'cols': [{
            'display': true,
            'name': 'Flex Column',
            'elements': [{
              'uid': 'CD9_q2Fvf',
              'display': true,
              'name': 'Image',
              'sid': 'lgpogktx6j--jYhZGrX_Bz',
              'hideFromSections': false,
              'component': 'ElImageV3',
              'group': 'Media',
              'layout': null,
              'options': {
                'content': {
                  'image': {
                    'display': true,
                    'type': 'ImageModV3',
                    'src': null,
                    'alt': 'Image',
                    'modal': {'data': {'modal_id': null}},
                    'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50},
                    'url': ''
                  }
                }
              },
              'editor': 'project',
              'temp_id': 'VZmZ9hdaJo'
            }],
            'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50},
            'sortIndex': {'lg': 0, 'md': 0, 'sm': 0},
            'sid': 'lq3mz432--3A4ofHx06w',
            'uid': '7RnNM9j99',
            'highlight': false
          }, {
            'special': true,
            'key': 'navigation',
            'mod': 'navigation-flex-col-mod-v2',
            'name': 'Nav Column',
            'sid': 'Uz96GLEcGy',
            'sortIndex': {'lg': 1, 'md': 1, 'sm': 1},
            'highlight': false
          }],
          'animations': {'animation': null, 'once': true, 'offset': 200, 'delay': 50}
        }
      },
      'temp_id': '23MJlRTY6G'
    }
  }
}

export const previews = {
  left: require('@builder/assets/svg/previews/price/left-1.svg'),
  right: null,
  main: require('@builder/assets/svg/previews/navbar/main-1.svg')
}

export default class Section extends SectionProvider {
  constructor (options = {}) {
    super('NavbarV3', options)

    this.name = name
    this.group = group
    this.ignoreGroup = true
    this.css = [['.--lgpogktx6j--lmPOn_f8KN--container { z-index: 1039; padding-right: 0px; }', '.--lq3mz432--3A4ofHx06w--flex-col-padding { padding: 0px; }', '.--lq3mz432--OFiJgs9lhG--flex-col-padding { padding: 0px; }', '.--lq3mz432--3A4ofHx06w--flex-col-el { width: 20%; background-color: rgba(255, 255, 255, 0); }', '.--lq3mz432--OFiJgs9lhG--flex-col-el { width: 100%; --width:100%; }', '.--lgpogktx6j--jYhZGrX_Bz--container { justify-content: center; }', '.--lgpogktx6j--jYhZGrX_Bz--wrapper { padding: 20px; }', '.--lq3mz432--OFiJgs9lhG--flex-col > div { align-items: center; justify-content: center; }', '.--lgpogktx6j--EAr_fuuhgH--flex { width: 100%; --width:100%; }', '.--lgpogktx6j--EAr_fuuhgH--flex-col-el { width: 100%; --width:100%; }', '.--lgpogktx6j--qCGWtUHQWx--flex-col-el { width: 20%; --width:20%; }', '.--lgpogktx6j--IOedpL_VSc--flex { width: 100%; --width:100%; align-items: center; padding: 0px; }', '.--lgpogktx6j--lmPOn_f8KN--flex { align-items: center; }', '.--lgpogktx6j--xhs67huAMW--wrapper { padding: 10px; justify-content: center; gap: 56px; }', '.--lgpogktx6j--sy0a5NLuwd--1 { margin: 20px; background-color: rgb(61, 130, 234); }', '.--lgpogktx6j--xhs67huAMW--link { font-size: 16px; color: rgb(0, 0, 0); }', '.--lgpogktx6j--xhs67huAMW--link:hover { color: rgb(61, 130, 234); }', '.--lgpogktx6j--EAr_fuuhgH--flex-col-padding { padding: 0px; }', '.--lgpogktx6j--qCGWtUHQWx--flex-col-padding { padding: 0px; }'], ['.--lgpogktx6j--EAr_fuuhgH--flex { width: 100%; --width:100%; }', '.--lgpogktx6j--IOedpL_VSc--flex { width: 100%; --width:100%; flex-wrap: wrap; }', '.--lgpogktx6j--qCGWtUHQWx--flex-col-el { width: 100%; --width:100%; }', '.--lgpogktx6j--xhs67huAMW--wrapper { flex-direction: column; justify-content: center; align-items: center; gap: 22px; }', '.--lq3mz432--OFiJgs9lhG--flex-col-el { background-color: rgb(250, 250, 250); }', '.--lq3mz432--OFiJgs9lhG--flex-col-padding { padding-top: 20px; padding-bottom: 20px; }', '.--lgpogktx6j--lmPOn_f8KN--close-icon { color: rgb(0, 0, 0); }', '.--lgpogktx6j--lmPOn_f8KN--icon { font-size: 20px; }', '.--lgpogktx6j--lmPOn_f8KN--open-icon { color: rgb(0, 0, 0); }'], ['.--lgpogktx6j--EAr_fuuhgH--flex { width: 100%; --width:100%; flex-wrap: wrap; }', '.--lgpogktx6j--IOedpL_VSc--flex { width: 100%; --width:100%; flex-wrap: wrap; }', '.--lq3mz432--3A4ofHx06w--flex-col-el { width: 50%; --width:50%; }', '.--lgpogktx6j--qCGWtUHQWx--flex-col-el { width: 100%; --width:100%; }', '.--lgpogktx6j--xhs67huAMW--wrapper { gap: 49px; flex-direction: column; justify-content: center; align-items: center; }', '.--lq3mz432--OFiJgs9lhG--flex-col-padding { padding-top: 20px; padding-bottom: 20px; }', '.--lgpogktx6j--sy0a5NLuwd--1 { width: 100%; }', '.--lq3mz432--OFiJgs9lhG--flex-col-el { width: 100%; --width:100%; }', '.--lgpogktx6j--jYhZGrX_Bz--container { justify-content: normal; }', '.--lq3mz432--3A4ofHx06w--flex-col-padding { padding-left: 0px; }']]
    this.sids = ['lgpogktx6j--lgIzvktx6j', 'lgpogktx6j--lmPOn_f8KN', 'lq3mz432--3A4ofHx06w', 'lgpogktx6j--jYhZGrX_Bz', 'lq3mz432--OFiJgs9lhG', 'lgpogktx6j--IOedpL_VSc', 'lgpogktx6j--EAr_fuuhgH', 'lgpogktx6j--xhs67huAMW', 'lgpogktx6j--qCGWtUHQWx', 'lgpogktx6j--sy0a5NLuwd']
    this.sid = ['lgpogktx6j']
    this.defaultOptions = defaultOptions
  }
}
